import { useEffect, useLayoutEffect, useMemo, useRef } from 'react';
import debounce from 'lodash/debounce';
export var useDebounce = function (callback, delay) {
    if (delay === void 0) { delay = 1000; }
    var callbackRef = useRef(callback);
    var debouncedRef = useRef(undefined);
    useLayoutEffect(function () {
        callbackRef.current = callback;
    });
    // Create the debounced function
    var debouncedFunction = useMemo(function () {
        var debounced = debounce(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return callbackRef.current.apply(callbackRef, args);
        }, delay);
        debouncedRef.current = debounced;
        return debounced;
    }, [delay]);
    // Cleanup on unmount
    useEffect(function () {
        return function () {
            var _a;
            (_a = debouncedRef.current) === null || _a === void 0 ? void 0 : _a.cancel();
        };
    }, []);
    return debouncedFunction;
};
